import { Button } from '@mantine/core';
import classes from './Button.module.css';

export const ButtonConfig = Button.extend({
  classNames: {
    root: classes.root,
  },
  defaultProps: {
    size: 'md',
  },
});
